var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collect',{attrs:{"title":"宿題","offset":1,"contents":[_vm.contents[1]]}})}
var staticRenderFns = []

export { render, staticRenderFns }